<template>
  <div class="existing-bet-display py-4">
    <v-alert
      color="info"
      variant="outlined"
      class="mb-4"
    >
      <template v-slot:prepend>
        <v-icon>mdi-check-circle</v-icon>
      </template>
      <div>
        <div class="font-weight-medium mb-2">{{ $t('messages.error.betExists') }}</div>
      </div>
    </v-alert>

    <div class="bet-details">
      <div class="d-flex justify-space-between mb-1">
        <span>{{ $t('myBets.details.selection') }}:</span>
        <span class="font-weight-medium">{{ bet.selection }}</span>
      </div>
      <div class="d-flex justify-space-between mb-1">
        <span>{{ $t('events.betting.betAmount') }}:</span>
        <span class="font-weight-medium">
          <Currency :amount="parseFloat(bet.amount)" />
        </span>
      </div>
      <div class="d-flex justify-space-between mb-1">
        <span>{{ $t('myBets.details.odds') }}:</span>
        <span class="font-weight-medium">{{ parseFloat(bet.odds).toFixed(2) }}</span>
      </div>
      <div class="d-flex justify-space-between mb-1">
        <span>{{ $t('events.betting.potentialWinning') }}:</span>
        <span class="font-weight-medium text-success">
          <Currency :amount="bet.amount * bet.odds" />
        </span>
      </div>
      <div class="d-flex justify-space-between">
        <span>Status:</span>
        <v-chip 
          :color="getStatusColor(bet.status)"
          size="small"
        >
          {{ getStatusText(bet.status) }}
        </v-chip>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import Currency from '@/components/Currency.vue'

// Props
const props = defineProps({
  bet: {
    type: Object,
    required: true
  }
})

// Composables
const { t } = useI18n()

// Methods
const getStatusColor = (status) => {
  const statusColors = {
    pending: 'warning',
    won: 'success',
    lost: 'error'
  }
  return statusColors[status] || 'grey'
}

const getStatusText = (status) => {
  const statusTexts = {
    pending: t('myBets.status.pending'),
    won: t('myBets.status.won'),
    lost: t('myBets.status.lost')
  }
  return statusTexts[status] || status
}
</script>

<style scoped>
.existing-bet-display .bet-details {
  background: rgba(var(--v-theme-surface-variant), 0.1);
  padding: 12px;
  border-radius: 8px;
}

.existing-bet-display .bet-details > div {
  font-size: 0.9rem;
}
</style>